import axios from 'axios';
import Auth from '../../auth/auth';

export const homeActions = {
  LOAD_SUMMARY_REQUEST: 'HOME_LOAD_SUMMARY_REQUEST',
  LOAD_SUMMARY_SUCCESS: 'HOME_LOAD_SUMMARY_SUCCESS',
  LOAD_SUMMARY_FAILURE: 'HOME_LOAD_SUMMARY_FAILURE',

  APPLY_ACTION_REQUEST: 'HOME_APPLY_ACTION_REQUEST',
  APPLY_ACTION_SUCCESS: 'HOME_APPLY_ACTION_SUCCESS',
  APPLY_ACTION_FAILURE: 'HOME_APPLY_ACTION_FAILURE',
};

const auth = new Auth();
const {getAccessToken} = auth;

function authHeaders() {
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'x-access-token': getAccessToken(),
  };
}

// Load the aggregated, permission-scoped Home dashboard summary.
export function loadHomeSummary({instanceId, schemaId} = {}) {
  return function(dispatch) {
    dispatch({type: homeActions.LOAD_SUMMARY_REQUEST});
    const params = new URLSearchParams();
    if (instanceId) params.append('instanceId', instanceId);
    if (schemaId) params.append('schemaId', schemaId);
    const qs = params.toString();
    axios.get(`${process.env.REACT_APP_API_URL}/home/summary${qs ? `?${qs}` : ''}`, {headers: authHeaders()})
        .then((r) => r.data)
        .then((json) => dispatch({type: homeActions.LOAD_SUMMARY_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: homeActions.LOAD_SUMMARY_FAILURE, payload: error, error: true}));
  };
}

// Approve / reject a pending change request from Home, then refresh the summary.
// Reuses the existing workflow action endpoint (server enforces permission).
export function homeApplyAction(requestId, action, scope = {}) {
  return function(dispatch) {
    dispatch({type: homeActions.APPLY_ACTION_REQUEST});
    axios.post(`${process.env.REACT_APP_API_URL}/workflow/changes/${requestId}/action`,
        {action},
        {headers: authHeaders()},
    )
        .then((r) => r.data)
        .then((json) => {
          dispatch({type: homeActions.APPLY_ACTION_SUCCESS, payload: json});
          dispatch(loadHomeSummary(scope));
        })
        .catch((error) => dispatch({type: homeActions.APPLY_ACTION_FAILURE, payload: error, error: true}));
  };
}
